import { Permission } from '@lucidtech/las-sdk-browser';

export const CRADL_ORGANIZATION = 'cradl:organization:cradl';
export const DEFAULT_REDIRECT_URL = '/';
export const EMAIL_CONTENT_TYPE = 'message/rfc822';
export const EXTERNAL_ORG_ID_CLAIM = 'external_org_id';
export const LAST_VISITED_AGENT_ID_KEY = 'cradl:lastVisitedAgentId';
export const MULTI_VALUE_COLUMN_NAME = '__MULTI_VALUE__';
export const ONBOARDING_COMPLETED_SESSION_KEY = 'onboardingCompleted';
export const PENDING_PAYMENT_METHOD_KEY = 'pendingPaymentMethod';
export const PENDING_PLAN_ID_KEY = 'pendingPlanId';
export const PROFILE_PICTURE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const REFETCH_AGENT_RUN_INTERVAL = 1000;

export const DEFAULT_TRIAL_DAYS = 14;

// Triggers
export const CREATE_AGENT_RUN_FROM_API_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-api`;
export const CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-email`;
export const CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-google-drive`;
export const CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-make`;
export const CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-manual`;
export const CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-microsoft-one-drive`;
export const CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-n8n`;
export const CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-power-automate`;
export const CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-agent-run-from-zapier`;

export const TRIGGER_FUNCTION_IDS = [
  CREATE_AGENT_RUN_FROM_API_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_EMAIL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_GOOGLE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MAKE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MANUAL_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_N8N_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_POWER_AUTOMATE_FUNCTION_ID,
  CREATE_AGENT_RUN_FROM_ZAPIER_FUNCTION_ID,
];

// Exports
export const EXPORT_TO_AIRTABLE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-airtable`;
export const EXPORT_TO_API_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-api`;
export const EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-google-drive`;
export const EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-google-sheets`;
export const EXPORT_TO_MAKE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-make`;
export const EXPORT_TO_MANUAL_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-manual`;
export const EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-microsoft-excel`;
export const EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-microsoft-one-drive`;
export const EXPORT_TO_N8N_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-n8n`;
export const EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-power-automate`;
export const EXPORT_TO_WEBHOOK_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-webhook`;
export const EXPORT_TO_ZAPIER_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:export-to-zapier`;

export const EXPORT_FUNCTION_IDS = [
  EXPORT_TO_AIRTABLE_FUNCTION_ID,
  EXPORT_TO_API_FUNCTION_ID,
  EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID,
  EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID,
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MANUAL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
];

// Formatters
export const FORMATTER_ADDRESS_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-address`;
export const FORMATTER_CLASSIFICATION_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-classification`;
export const FORMATTER_COUNTRY_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-country`;
export const FORMATTER_CURRENCY_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-currency`;
export const FORMATTER_CUSTOM_CODE_FUNCTION_ID = '__CUSTOM_CODE__';
export const FORMATTER_DATE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-date`;
export const FORMATTER_DATE_TIME_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-date-time`;
export const FORMATTER_EMAIL_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-email`;
export const FORMATTER_IBAN_NUMBER_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-iban-number`;
export const FORMATTER_NUMERIC_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-numeric`;
export const FORMATTER_PHONE_NUMBER_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-phone-number`;
export const FORMATTER_REGEX_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-regex`;
export const FORMATTER_SOCIAL_SECURITY_NUMBER_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-social-security-number`;
export const FORMATTER_TIME_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:formatter-time`;

// Hooks
export const HOOK_EVALUATE_DOCUMENT = `${CRADL_ORGANIZATION}/cradl:function:hook-evaluate-document`;
export const HOOK_EVALUATE_PREDICTION = `${CRADL_ORGANIZATION}/cradl:function:hook-evaluate-prediction`;

// Other Actions
export const CREATE_PREDICTION_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-prediction`;
export const CREATE_VALIDATION_TASK_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:create-validation-task`;

// Validators
export const VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:validator-cannot-be-empty`;
export const VALIDATOR_CONFIDENCE_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:validator-confidence`;
export const VALIDATOR_CUSTOM_CODE_FUNCTION_ID = '__CUSTOM_CODE__';
export const VALIDATOR_DATABASE_MATCH_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:validator-database-match`;
export const VALIDATOR_LOGEX_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:validator-logex`;
export const VALIDATOR_REGEX_FUNCTION_ID = `${CRADL_ORGANIZATION}/cradl:function:validator-regex`;

export const DEFAULT_SELECTED_NODE = 'default-selected-node';

export const DEFAULT_MAX_PAGES = 3;

export const STATUS_TO_NAME: Record<string, string> = {
  'ready-for-review': 'Flagged for review',
  'review-in-progress': 'Review in progress',
  archived: 'Archived',
  completed: 'Completed',
  error: 'Error',
  running: 'Agent is working',
};

// Roles and permissions
export enum ManagedRole {
  Admin = 'cradl:role:administrator',
  Member = 'cradl:role:member',
  Developer = 'cradl:role:developer',
  Validator = 'cradl:role:validator',
  Reviewer = 'cradl:role:reviewer',
}

export const DefaultPermissions: Record<string, Permission> = {
  AllAgentsWrite: { resourceId: 'cradl:agent:*', action: '*', effect: 'allow' },
};
